// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__Sbv0I","popup":"styles_popup__2UjTN"};